import(/* webpackMode: "eager" */ "/vercel/path0/components/bottom-navbar/index.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/navbar/index.tsx")